<template>
  <div class="page container">
    
    <Menu></Menu>
    <el-tabs v-if='curso'>
      <el-tab-pane label="Descrição">
        <conteudo-descricao :data='curso'></conteudo-descricao>
      </el-tab-pane>
      <el-tab-pane label="Imagens">
        <conteudo-conteudo :data='curso'></conteudo-conteudo>
      </el-tab-pane>
      <el-tab-pane label="Recursos">
        <conteudo-recursos :data='curso'></conteudo-recursos>
      </el-tab-pane>
    </el-tabs>
    
  </div>
</template>

<script>

  import Menu from './_menu';
  import uuid from 'uuid/v4';
  import ConteudoConteudo from './conteudo/_conteudo';
  import ConteudoDescricao from './conteudo/_descricao'
  import ConteudoRecursos from './conteudo/_recurso'
  import * as R from 'ramda';
  import axios from 'axios'

  export default {
    components: {
      Menu,
      ConteudoConteudo,
      ConteudoDescricao,
      ConteudoRecursos
    },
    data() {
      return {
       curso: null
      }
      
    },
    methods: {
      addClass(s) {
        const num = s.contents.length+1;
        s.contents.push({
          id: num, 
          uuid: uuid(),
          title: `Sem título de aula`, 
          views: 15, 
          inserted_at: '000', 
          updated_at: '000', 
          content: {}, 
          description: {}, 
          resources: {}, 
          ublished: false, 
          _activeTab: null, 
          _viewOption: null
        });
        console.log(s)
      },
      addSection() {
        const num = this.sections.length+1;
        this.sections.push({
          id: num, 
          uuid: uuid(),
          title: `Sem título de seção`, 
          inserted_at: '000',
          updated_at: '000', 
          contents: []
        })
      },
      toggleDetails(aula){
        if(aula._viewOption == 'details'){
          aula._viewOption = null;
        }else{
          aula._viewOption = 'details';
        }
        
      },
      removeClass(section, aula) {
        const idx = R.findIndex(R.propEq('uuid', aula.uuid))(section.contents);
        if(idx>=0){
          section.contents.splice(idx, 1);
        }
      },
      removeSection(section) {
        const idx = R.findIndex(R.propEq('uuid', section.uuid))(this.sections);
        if(idx>=0){
          this.sections.splice(idx, 1);
        }
      },
      handleCommand(c, aula, section){

        aula._viewOption = c;
        if(c=='minimize'){
          aula._viewOption = null;
          return;
        }
      },
      getCurso(){
        const curso_id = this.$route.params.curso;
        global.Loading.begin(`Carregando o curso #${curso_id}`);
        axios.get(`${global.base}/api/admin/curso/${curso_id}`,{
          headers: { 'authorization': `bearer ${this.$store.state.session.jwt}` },
          }).then((r)=>{
            global.Loading.end();
            this.curso = r.data;
          }).catch(()=>{
            global.Loading.end();
          })
      }
    },
    mounted(){
      this.getCurso();
    }

  };
</script>

<style scope>
  .td-view{
    padding: 10px 0px;
    text-align: right;
  }

  .section-title{
    padding: 10px 0px;
    text-align: left;

  }
  .section-title .btns-class-title-section{
    opacity:0;
    pointer-events: none;
    transition: 0.5s all; 
  }
  .section-title:hover{
    color:#000;
  }
  .section-title:hover .btns-class-title-section{
    opacity:1;
    pointer-events: auto; 
  }
  .conteudo-secao{
    background: #FAFAFA;
    padding:20px;
    margin: 20px 0px;
  }
  .conteudo-aula{
    background: #FFF;
    border:1px solid #EBEBEB!important;
  }
  .conteudo-aula-title{
    background:#F5F5F5;
    border:1px solid #EBEBEB;
  }

</style>